import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  HouseOutlined,
  PersonOutlineOutlined,
  FactCheckOutlined,
} from "@mui/icons-material";
import LayersIcon from "@mui/icons-material/Layers";

import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Stack } from "@mui/system";
//import iconProntuario from "../images/iconProntuario.svg";
import { ReactComponent as IconUsers } from "../images/iconUsers.svg";
import { ReactComponent as IconCalendar } from "../images/iconCalendar.svg";
import { ReactComponent as IconVaccination } from "../images/iconVaccination.svg";
import { NoteIcon } from "../pages/HomePaciente/CardHome";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

const breadcrumbNameMap = {
  // "/home": "Home",
  "/cadastro": "Cadastro de profissional de saúde",
  "/cadastro-paciente": "Cadastro de novo paciente",
  "/gerenciamento-sistema": "Gerenciamento do sistema",
  "/gerenciamento-sistema/gerenciamento-usuarios": "Gerenciamento de usuários",
  "/pacientes": "Pacientes",
  "/agendamentos": "Agendamentos",
  "/agendamentos/novo-agendamento": "Novo agendamento",
  "/pacientes/prontuario": "Prontuário do paciente",
  "/pacientes/primeira-avaliacao": "Prontuário do paciente",
  "/pacientes/primeira-consulta": "Consulta em andamento",
  "/pacientes/consulta-rotina": "Consulta em andamento",
  "/pacientes/dados-paciente": "Prontuário do paciente",
  "/pacientes/consulta-demais-profissionais": "Prontuário do paciente",
  "/escalas": "Escala",
  "/escalas/registrar-escala": "Registrar",
  "/paciente": "Paciente",
  "/paciente/home": "Home",
  "/paciente/geracesso": "Gerenciamento de acessos",
  "/pacientes/detalhes-cadastro": "Detalhes",
  "/pacientes/progresso-multidisciplinar": "Progresso multidisciplinar",
};

const breadcrumbIconMap = {
  // "/home": <HouseOutlined key={1} fontSize="small" sx={{ color: "#3E94C2" }} />,
  "/cadastro": (
    <PersonOutlineOutlined fontSize="small" key={2} sx={{ color: "#3E94C2" }} />
  ),
  "/cadastro-paciente": (
    <PersonOutlineOutlined fontSize="small" key={3} sx={{ color: "#3E94C2" }} />
  ),
  "/gerenciamento-sistema": (
    <LayersIcon fontSize="small" key={4} sx={{ color: "#3E94C2" }} />
  ),
  "/gerenciamento-sistema/gerenciamento-usuarios": (
    <PersonOutlineOutlined fontSize="small" key={4} sx={{ color: "#3E94C2" }} />
  ),
  "/pacientes": (
    <IconUsers key={5} fontSize="small" style={{ color: "#3E94C2" }} />
  ),
  "/agendamentos": (
    <IconCalendar key={6} fontSize="small" style={{ color: "#3E94C2" }} />
  ),
  "/pacientes/prontuario": (
    <PersonOutlineOutlined
      key={7}
      fontSize="small"
      style={{ color: "#3E94C2" }}
    />
  ),
  "/pacientes/primeira-avaliacao": (
    <PersonOutlineOutlined
      key={8}
      fontSize="small"
      style={{ color: "#3E94C2" }}
    />
  ),
  "/pacientes/primeira-consulta": (
    <IconVaccination key={9} fontSize="small" style={{ color: "#3E94C2" }} />
  ),
  "/pacientes/consulta-demais-profissionais": (
    <IconVaccination key={9} fontSize="small" style={{ color: "#3E94C2" }} />
  ),
  "/pacientes/consulta-rotina": (
    <IconVaccination key={10} fontSize="small" style={{ color: "#3E94C2" }} />
  ),
  "/pacientes/dados-paciente": (
    <iconProntuario key={11} fontSize="small" style={{ color: "#3E94C2" }} />
  ),
  "/paciente/home": (
    <HouseOutlined key={12} fontSize="small" style={{ color: "#3E94C2" }} />
  ),
  "/paciente": (
    <PersonOutlineOutlined
      key={13}
      fontSize="small"
      style={{ color: "#3E94C2" }}
    />
  ),
  "/paciente/geracesso": (
    <Box
      sx={{
        svg: {
          width: "20px",
          height: "20px",
          pt: "3px",
        },
      }}
    >
      <NoteIcon key={14} fontSize="small" style={{ color: "#3E94C2" }} />
    </Box>
  ),
  "/pacientes/progresso-multidisciplinar": (
    <Box
      sx={{
        svg: {
          width: "20px",
          height: "20px",
          pt: "3px",
        },
      }}
    >
      <FactCheckOutlined
        key={14}
        fontSize="small"
        style={{ color: "#3E94C2" }}
      />
    </Box>
  ),
};

const MuiBreadcrumbs = (props) => {
  const {
    navigate,
    location: { pathname },
  } = props.router;

  const pathnames = pathname
    .replace(/\/$/, "")
    .replace(/\/\d+$/, "")
    .split("/")
    .filter((x) => x !== "");

  return (
    <Box sx={{ marginBottom: "24px" }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        maxItems={3}
        aria-label="breadcrumb"
      >
        <Link
          underline="hover"
          onClick={() => navigate("/home")}
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#3E94C2",
            cursor: "pointer",
          }}
        >
          <HouseOutlined
            key={1}
            fontSize="small"
            alt="prontuarioELA"
            sx={{ color: "#3E94C2" }}
          />

          <Box marginLeft={1}>Home</Box>
        </Link>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          if (routeTo === "/home") {
            return null;
          }
          return (
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              spacing={1}
              key={index}
            >
              {breadcrumbIconMap[routeTo]}
              {isLast
                ? [
                    <Typography key={name} sx={{ color: "#1E729F" }}>
                      {breadcrumbNameMap[routeTo]}
                    </Typography>,
                  ]
                : [
                    <Link
                      underline="hover"
                      key={name}
                      onClick={() => navigate(routeTo)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {breadcrumbNameMap[routeTo]}
                    </Link>,
                  ]}
            </Stack>
          );
        })}
      </Breadcrumbs>
      <Box>
        <Outlet />
      </Box>
    </Box>
  );
};

export default withRouter(MuiBreadcrumbs);
